const GetSmartCubePageFilterReducer = (state = { type: 'LOADING_SMARTCUBE_PAGE_FILTER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SMARTCUBE_PAGE_FILTER_ACTION':
            return { ...state, type: 'LOADING_SMARTCUBE_PAGE_FILTER_ACTION', loading: true };
        case 'SUCCESS_SMARTCUBE_PAGE_FILTER_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SMARTCUBE_PAGE_FILTER_ACTION':
            return { ...state, type: 'ERROR_SMARTCUBE_PAGE_FILTER_ACTION', loading: false, error: action.error };
        case 'RESET_SMARTCUBE_PAGE_FILTER_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSmartCubeChartFiltersReducer = (state = { type: 'LOADING_SMARTCUBE_CHART_FILTERS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SMARTCUBE_CHART_FILTERS_ACTION':
            return { ...state, type: 'LOADING_SMARTCUBE_CHART_FILTERS_ACTION', loading: true };
        case 'SUCCESS_SMARTCUBE_CHART_FILTERS_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SMARTCUBE_CHART_FILTERS_ACTION':
            return { ...state, type: 'ERROR_SMARTCUBE_CHART_FILTERS_ACTION', loading: false, error: action.error };
        case 'RESET_SMARTCUBE_CHART_FILTERS_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSmartCubeMarketSizeForecastReducer = (state = { type: 'LOADING_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION':
            return { ...state, type: 'LOADING_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION', loading: true };
        case 'SUCCESS_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION':
            return { ...state, type: 'ERROR_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION', loading: false, error: action.error };
        case 'RESET_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSmartCubeCategoryRiskReducer = (state = { type: 'LOADING_SMARTCUBE_CATEGORY_RISK_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SMARTCUBE_CATEGORY_RISK_ACTION':
            return { ...state, type: 'LOADING_SMARTCUBE_CATEGORY_RISK_ACTION', loading: true };
        case 'SUCCESS_SMARTCUBE_CATEGORY_RISK_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SMARTCUBE_CATEGORY_RISK_ACTION':
            return { ...state, type: 'ERROR_SMARTCUBE_CATEGORY_RISK_ACTION', loading: false, error: action.error };
        case 'RESET_SMARTCUBE_CATEGORY_RISK_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSmartCubeTextWidgetsReducer = (state = { type: 'LOADING_SMARTCUBE_TEXT_WIDGETS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SMARTCUBE_TEXT_WIDGETS_ACTION':
            return { ...state, type: 'LOADING_SMARTCUBE_TEXT_WIDGETS_ACTION', loading: true };
        case 'SUCCESS_SMARTCUBE_TEXT_WIDGETS_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SMARTCUBE_TEXT_WIDGETS_ACTION':
            return { ...state, type: 'ERROR_SMARTCUBE_TEXT_WIDGETS_ACTION', loading: false, error: action.error };
        case 'RESET_SMARTCUBE_TEXT_WIDGETS_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSmartCubePriceTrendReducer = (state = { type: 'LOADING_SMARTCUBE_PRICE_TREND_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SMARTCUBE_PRICE_TREND_ACTION':
            return { ...state, type: 'LOADING_SMARTCUBE_PRICE_TREND_ACTION', loading: true };
        case 'SUCCESS_SMARTCUBE_PRICE_TREND_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SMARTCUBE_PRICE_TREND_ACTION':
            return { ...state, type: 'ERROR_SMARTCUBE_PRICE_TREND_ACTION', loading: false, error: action.error };
        case 'RESET_SMARTCUBE_PRICE_TREND_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSmartCubeCostDriversReducer = (state = { type: 'LOADING_SMARTCUBE_COST_DRIVERS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SMARTCUBE_COST_DRIVERS_ACTION':
            return { ...state, type: 'LOADING_SMARTCUBE_COST_DRIVERS_ACTION', loading: true };
        case 'SUCCESS_SMARTCUBE_COST_DRIVERS_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SMARTCUBE_COST_DRIVERS_ACTION':
            return { ...state, type: 'ERROR_SMARTCUBE_COST_DRIVERS_ACTION', loading: false, error: action.error };
        case 'RESET_SMARTCUBE_COST_DRIVERS_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSmartCubeCostStructureBreakdownReducer = (state = { type: 'LOADING_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION':
            return { ...state, type: 'LOADING_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION', loading: true };
        case 'SUCCESS_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION':
            return { ...state, type: 'ERROR_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION', loading: false, error: action.error };
        case 'RESET_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

export {
    GetSmartCubePageFilterReducer,
    GetSmartCubeChartFiltersReducer,
    GetSmartCubeMarketSizeForecastReducer,
    GetSmartCubeCategoryRiskReducer,
    GetSmartCubeTextWidgetsReducer,
    GetSmartCubePriceTrendReducer,
    GetSmartCubeCostDriversReducer,
    GetSmartCubeCostStructureBreakdownReducer
};
